export default __webpack_public_path__ + "static/media/img3.fc62e22e.jpg";